import React from 'react';
import { Link } from 'react-router-dom';
import Main from '../layouts/Main';
import { useLanguage } from '../components/LanguageContext';

const PageNotFound = () => {
  const { t } = useLanguage();

  return (
    <Main title={t.notFound.title}>
      <article className="post" id="not-found">
        <header>
          <div className="title">
            <h2>{t.notFound.heading}</h2>
          </div>
        </header>
        <p>{t.notFound.back} <Link to="/">{t.notFound.home}</Link>.</p>
      </article>
    </Main>
  );
};

export default PageNotFound;
